var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "row p-3 mt-2 shadow-sm bg-white",
      class: { selected: _vm.auctionBatch.lote.loteId === _vm.selectedBatch }
    },
    [
      _c("div", { staticClass: "col-11" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-2 text-center text-primary" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: "Folio Lote",
                    expression: "'Folio Lote'"
                  }
                ],
                staticClass: "cursor-pointer",
                class: { "text-success": _vm.wasCopied },
                attrs: { "data-cy": "file-number" },
                on: {
                  click: function($event) {
                    return _vm.copyToClipboard(
                      _vm.auctionBatch.lote.loteId,
                      _vm.auctionBatch.lote.folio
                    )
                  }
                }
              },
              [_vm._v(" " + _vm._s(_vm.auctionBatch.lote.folio) + " ")]
            )
          ]),
          _c(
            "div",
            { staticClass: "col-2" },
            [
              _vm.batchesStates[_vm.auctionBatch.lote.estado]
                ? _c(
                    "vs-chip",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value:
                            "" +
                            _vm.batchesStates[_vm.auctionBatch.lote.estado]
                              .label,
                          expression:
                            "`${batchesStates[auctionBatch.lote.estado].label}`"
                        }
                      ],
                      attrs: {
                        color:
                          _vm.batchesStates[_vm.auctionBatch.lote.estado].color
                      }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.batchesStates[_vm.auctionBatch.lote.estado]
                              .label
                          ) +
                          " "
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          ),
          _c("div", { staticClass: "col-8" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-4" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.auctionBatch.lote.loteadoraValor || "-") +
                    " "
                )
              ]),
              _c("div", { staticClass: "col-2" }, [
                _vm.auctionBatch.lote.requiereVb === 0
                  ? _c("span", [_vm._v(" No ")])
                  : _vm._e(),
                _vm.auctionBatch.lote.requiereVb === 1
                  ? _c("span", [_vm._v(" Si ")])
                  : _vm._e()
              ]),
              _c("div", { staticClass: "col-2" }, [
                _vm.auctionBatch.lote.esExLote === _vm.IS_EXISTING_BATCH
                  ? _c("span", [_vm._v(" Si ")])
                  : _vm._e(),
                _vm.auctionBatch.lote.esExLote === _vm.IS_NOT_EXISTING_BATCH
                  ? _c("span", [_vm._v(" No ")])
                  : _vm._e()
              ]),
              _c("div", { staticClass: "col-3" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.auctionBatch.lote.calidadJuridicaNombre || "-") +
                    " "
                )
              ])
            ])
          ])
        ]),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-11 offset-1" },
            [
              _vm.auctionBatch.lote.montoMinimo
                ? _c(
                    "vs-chip",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Monto Mínimo",
                          expression: "'Monto Mínimo'"
                        }
                      ],
                      staticClass: "mr-4",
                      attrs: { color: "#7d84ad" }
                    },
                    [
                      _c("vs-avatar", { attrs: { icon: "monetization_on" } }),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("amount")(_vm.auctionBatch.lote.montoMinimo)
                          ) +
                          " "
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "vs-chip",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: "Fecha de Emisión",
                      expression: "'Fecha de Emisión'"
                    }
                  ],
                  staticClass: "mr-4",
                  attrs: { color: "#ff9800" }
                },
                [
                  _c("vs-avatar", { attrs: { icon: "date_range" } }),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm._f("dateFormat")(
                          _vm.auctionBatch.lote.fechaCreacion
                        )
                      ) +
                      " "
                  )
                ],
                1
              ),
              _c(
                "vs-chip",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: "Usuario Creador",
                      expression: "'Usuario Creador'"
                    }
                  ],
                  staticClass: "mr-4",
                  attrs: { color: "primary" }
                },
                [
                  _c("vs-avatar", { attrs: { icon: "person" } }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.auctionBatch.lote.usuario.alias || "-") +
                      " "
                  )
                ],
                1
              ),
              _vm.auctionBatch.subasta
                ? _c(
                    "vs-chip",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Subasta Asociada",
                          expression: "'Subasta Asociada'"
                        }
                      ],
                      staticClass: "mr-4",
                      attrs: { color: "#7d84ad" }
                    },
                    [
                      _c("vs-avatar", { attrs: { icon: "gavel" } }),
                      _vm._v(" " + _vm._s(_vm.auctionBatch.subasta.folio) + " ")
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showPositionInfo
                ? _c(
                    "vs-chip",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Posición Subasta",
                          expression: "'Posición Subasta'"
                        }
                      ],
                      staticClass: "mr-4",
                      attrs: { color: "primary" }
                    },
                    [
                      _c("vs-avatar", { attrs: { icon: "location_on" } }),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.auctionBatch.lote.loteadora.codigo +
                              " -" +
                              _vm.auctionBatch.subasta.gestora.codigoAduana +
                              " -" +
                              _vm.auctionBatch.lote.folio +
                              " -" +
                              _vm.auctionBatch.lote.posicion
                          ) +
                          " "
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.auctionBatch.lote.devolucionesCantidad > 0
                ? _c(
                    "vs-chip",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Número de devoluciones",
                          expression: "'Número de devoluciones'"
                        }
                      ],
                      staticClass: "mr-4",
                      attrs: { color: "#7d84ad" }
                    },
                    [
                      _c("vs-avatar", { attrs: { icon: "replay" } }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.auctionBatch.lote.devolucionesCantidad) +
                          " "
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _c(
        "div",
        { staticClass: "col-1 d-flex justify-center" },
        [
          _vm._t(
            "actions",
            [
              _c("AuctionHistoryOptions", {
                ref: "file-options-" + _vm.auctionBatch.lote.loteId,
                attrs: {
                  auctionBatch: _vm.auctionBatch.lote,
                  "select-batch": _vm.selectBatch
                },
                on: { "reload-list": _vm.handleReloadList }
              })
            ],
            { auctionBatch: _vm.auctionBatch }
          )
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }